import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Section from '@ui/Section'
import ButtonsRow from '@ui/ButtonsRow'

@observer
export default class Row extends Component {
  handleChange = value => {
    const { onChange, name } = this.props
    onChange(name, value)
  }

  handleChangeTitle = ({ title }) => {
    const { onEdit, id } = this.props
    onEdit({ id, text: title })
  }

  render() {
    const { id, title, columns, currentValue, editable, onRemove, inactive, mode } =
      this.props
    const buttons = columns.map(column => ({
      id: `${title}-${column.value}`,
      ...column
    }))

    return (
      <Section
        size='h3'
        title={title}
        className='matrix-item'
        editable={editable}
        onBlur={this.handleChangeTitle}
        titleRequired
        hideDescription
      >
        <ButtonsRow
          id={id}
          buttons={buttons}
          onSelect={this.handleChange}
          selected={currentValue}
          editable={editable}
          onRemove={onRemove}
          inactive={inactive}
          mode={mode}
        />
      </Section>
    )
  }
}
